import { render, staticRenderFns } from "./learning.vue?vue&type=template&id=1535a237&scoped=true&lang=pug"
import script from "./learning.vue?vue&type=script&lang=ts"
export * from "./learning.vue?vue&type=script&lang=ts"
import style0 from "./learning.vue?vue&type=style&index=0&id=1535a237&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1535a237",
  null
  
)

export default component.exports